<template>
    <configured-layout
        title="Select Options"
        :breadcrumbs="breadcrumbs"
        :disabled="loading"
        @next="onNext"
    >
        <b-tabs
            v-if="headerItems"
            v-model="optionsTabIndex"
            class="option-tabs"
        >
            <b-tab
                v-for="(options, title) in headerItems"
                :key="title"
                :title="title"
            >
                <options-list :options="options" />
            </b-tab>
        </b-tabs>
    </configured-layout>
</template>

<script>
import _ from "lodash";
import { get, sync } from "vuex-pathify";
import ConfiguredLayout from "./components/Layout";
import loader from "Modules/Configure/mixins/loader";
import OptionsList from "Modules/Configure/components/OptionsList";

export default {
    name: "Options",

    components: {
        OptionsList,
        "configured-layout": ConfiguredLayout
    },

    mixins: [loader],

    props: {
        styleId: {
            required: true,
            type: String
        }
    },

    computed: {
        loading: get("configure/loading"),
        headerItems: get("configure/headerItems"),
        optionsTabIndex: sync("configure/optionsTabIndex"),
        powertrainOptions: get("configure/powertrainOptions"),
        breadcrumbs() {
            const breadcrumbs = [
                {
                    text: this.vehicleName,
                    href: this.vehicleDetailsUrl
                }
            ];

            if (_.size(this.powertrainOptions) > 0) {
                breadcrumbs.push({
                    text: "Select Powertrain",
                    to: { name: "powertrain" }
                });
            }

            breadcrumbs.push({
                text: "Select Color",
                to: { name: "color" }
            });

            breadcrumbs.push({
                text: "Select Options",
                active: true
            });

            return breadcrumbs;
        }
    },

    methods: {
        onNext() {
            if (this.optionsTabIndex >= _.size(this.headerItems) - 1) {
                document.location = this.vehicleDetailsUrl;
            } else {
                this.optionsTabIndex++;
            }
        }
    }
};
</script>
